import { useLayoutEffect, useEffect, useState, useContext } from "react";
import { usePreference } from "../../../context/usePreference";
import interact from 'interactjs'
import { MinuteGraphicLine } from "./MinuteGraphicLine";
import { MinuteGraphicPie } from "./MinuteGraphicPie";
import { MinuteGraphicImage } from "./MinuteGraphicImage";
import Slider from "../Slider"
import { DivMinuteEnum, SelectTypeGridEnum } from "../../../utils/enums";
import { getChartDivisionsExp } from "../../../context/utils";
import { AudienceContext } from "../../../context/AudienceContext";
import { NetworkAlertContext } from '../../../context/NetworkAlertContext';
import { UiContext } from "../../../context/UiContext";

export function MinuteGraphic({
  heading,
  lastAudience,
  data,
  dataPie,
  heightPie,
  Indice,
  selectTypeGrid,
  divMinute,
  audience
}) {
  const { isMobile, hasShortHeightDetail } = useContext(UiContext);
  const { doAudienceImageEmissora } = useContext(AudienceContext);

  const { setShowInfo } = useContext(NetworkAlertContext);
  const u = usePreference();
  const [isDragging, setIsDragging] = useState(false);
  let xMin = 0;
  let xMax = 0;
  const [scrollValue, setScrollValue] = useState(0);
  const divTableMinuteLeft = document.getElementById('divTableMinuteLeft')!;
  const divTableMinuteRight = document.getElementById('divTableMinuteRight')!;
  const sliderHandleElement = document.getElementById('table-slider-handle')!;
  const sliderEnabledRegion = document.getElementById('slider-enabled-region')!;
  const sliderElement = document.getElementById('table-slider')!;
  const RootComponent = document.getElementById("root");
  const RootWidth = parseFloat(RootComponent != undefined ? getComputedStyle(RootComponent).width : '0');
  let chartDivisions = sliderEnabledRegion != null ? getChartDivisionsExp(audience, sliderEnabledRegion.offsetWidth).map(x => x + 30) : [];

  useLayoutEffect(() => { }, []);
  useEffect(() => { }, []);
  let scrollTimeout: NodeJS.Timeout;

  const handleScroll = () => {
    if (scrollTimeout) {
      hideShowInfo();
    }
    scrollTimeout = setTimeout(() => {
      const divTableMinuteRight = document.getElementById('divTableMinuteRight');
      if (divTableMinuteRight) {
        setScrollValue(divTableMinuteRight.scrollTop || 0);
      }
    }, 150);
  };

  const addScrollListener = () => {
    const divTableMinuteRight = document.getElementById('divTableMinuteRight');
    if (divTableMinuteRight && selectTypeGrid === SelectTypeGridEnum.Image) {
      divTableMinuteRight.addEventListener('scroll', handleScroll);
    }
    return divTableMinuteRight;
  };

  const removeScrollListener = (divTableMinuteRight) => {
    if (divTableMinuteRight) {
      divTableMinuteRight.removeEventListener('scroll', handleScroll);
    }
  };
//console.log("Tabela " + document.querySelectorAll("#divTableMinuteRight table tbody tr").length, "Gráfico " +document.querySelectorAll("#minuteGraphicImage rect").length);
  useEffect(() => {
    if (selectTypeGrid === SelectTypeGridEnum.Image)
      doAudienceImageEmissora();
    const divTableMinuteRight = document.getElementById('divTableMinuteRight');
    if (divTableMinuteRight && selectTypeGrid === SelectTypeGridEnum.Image) {
      divTableMinuteRight.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (divTableMinuteRight) {
        divTableMinuteRight.removeEventListener('scroll', handleScroll);
      }
    };
  }, [selectTypeGrid]);

  useEffect(() => {
    syncScrollPositions();
  }, [scrollValue]);

  const syncScrollPositions = () => {
    if (isDragging === false && divTableMinuteRight != null && divTableMinuteLeft != null && divTableMinuteRight.scrollTop !== divTableMinuteLeft.scrollTop) {
      divTableMinuteLeft.scrollTop = divTableMinuteRight.scrollTop;
    }
  };

  function hideShowInfo() {
    setTimeout(() => setShowInfo(false), 3000);
  }
  const handleSlider = (value, target, xMin, xMax) => {
    let x = value,
      limitedX = Math.max(xMin, Math.min(xMax, x));
    // translate the element
    target.style.webkitTransform =
      target.style.transform =
      'translate(' + limitedX + 'px, ' + '0px)';
    target.dataset.x = String(limitedX);
  }
  const getIndexForX = (x: number, positions: number[]) => {
    for (let i = 0; i < positions.length - 1; i++) {
      if (x >= positions[i] && x < positions[i + 1]) {
        return (positions.length - 1) - i - 1;
      }
    }
    // Caso x seja maior ou igual ao último valor do array
    if (x >= positions[positions.length - 1]) {
      return 0;
    }
    // Caso x seja menor que o primeiro valor do array
    return -1;
  };
  const contentGraphic = renderContentGraphic(Indice, divMinute, heading, lastAudience, data, dataPie, heightPie);

  const contentGraphicImage = renderContentGraphicImage(audience, heading, RootWidth, isMobile, hasShortHeightDetail);

  const headerImageHeight = document.getElementById('header') != null ?
    document.getElementById('header')!.offsetHeight + 30
    : 0;
  let scrollHeight = (divTableMinuteRight ? divTableMinuteRight.scrollHeight - (headerImageHeight) : 0);
  //the current minute is located at what percentage of the full (visible) table?
  //we use the scroll position to figure it out
  let tablePositionPercent = divTableMinuteRight != null && divTableMinuteLeft != null ? (
    (divTableMinuteRight.scrollTop) /
    (scrollHeight)
  ) : 0;

  let sliderPositionPercent = Math.sqrt(tablePositionPercent);//exponential

  let percent = 1 - sliderPositionPercent;

  if (sliderElement && sliderHandleElement && sliderEnabledRegion) {
    let sliderWidth = sliderEnabledRegion != null ? sliderEnabledRegion.offsetWidth : 0;
    let clientHeight = divTableMinuteRight != null ? divTableMinuteRight.clientHeight : 0;
    let tablePercentLimit = (scrollHeight - clientHeight + headerImageHeight) / scrollHeight;
    let sliderPercentLimit = Math.sqrt(tablePercentLimit);

    let unreachableSliderRegionWidth = sliderWidth * (1 - sliderPercentLimit);
    xMax = chartDivisions[chartDivisions.length - 1];
    xMin = 30 + unreachableSliderRegionWidth;
    let x0 = 30 + percent * (sliderWidth);

    if (!isDragging) {
      handleSlider(x0, sliderHandleElement, xMin, xMax);
      u.setMinuteImage(getIndexForX(x0, chartDivisions));
    }

    sliderHandleElement.style.opacity = "1";
    interact('.handle')
      .draggable({
        inertia: false,
        listeners: {
          move: function (event) {
            setIsDragging(true);
            let target = event.target,
              // keep the dragged position in the data-x/data-y attributes
              x = (parseFloat(target.dataset.x || '0') || 0) + event.dx,
              limitedX = Math.max(xMin, Math.min(xMax, x)),
              scrollPercent = 1 - ((limitedX - 30) / sliderWidth);
            if (divTableMinuteRight != null && selectTypeGrid == SelectTypeGridEnum.Image) {
              let newScrollValue = Math.pow(scrollPercent, 2) * scrollHeight;
              divTableMinuteRight.scrollTop = newScrollValue;
            }
            handleSlider(x, target, xMin, xMax);

          },
          end: function () {
            setIsDragging(false);
          }
        }

      });
  }
  return (
    <div
      id="minuteGraphic"
      data-testid="minuteGraphic"
      style={{
        display: "block",
      }}
    >
      {selectTypeGrid === 3 ? contentGraphicImage : contentGraphic}
    </div>
  );
}


const renderContentGraphic = (Indice, divMinute, heading, lastAudience, data, dataPie, heightPie) => {
  return (Indice === 0 || Indice === 3 || Indice === 4) && divMinute === DivMinuteEnum.Minute ? (
    <MinuteGraphicLine
      heading={heading}
      lastAudience={lastAudience}
      data={data}
      divMinute={divMinute}
    />
  ) : (
    <MinuteGraphicPie
      heading={heading}
      lastAudience={lastAudience}
      dataPie={dataPie}
      heightPie={heightPie}
    />
  );
};

const renderContentGraphicImage = (audience, heading, RootWidth, isMobile, hasShortHeightDetail) => {

  return audience != null ? (
    <>
      <MinuteGraphicImage
        heading={heading}
        data={audience} />
      <div
        style={{
          backgroundColor: "#000",
          display: isMobile && hasShortHeightDetail ? 'none' : 'block'
        }}>
        <Slider {...{ tableWidth: RootWidth }} />
      </div>
    </>
  ) : null;
};

